import type { TValueKeyVariant } from '../models/common';

export const valueKeyVariants: {
    [key: string]: keyof TValueKeyVariant;
} = {
    id: 'key',
    key: 'key',
    label: 'content',
    content: 'content',
};
